import React, { Component } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import "./VisionAndMission.css";

class VisionAndMissionPage extends Component {
  render() {
    return (
      <>
        <div style={{ textAlign: "justify" }}>
          <Container className="global-container text-center" fluid>
            <Row>
              <Col>
                <h3>UNDERGRADUATE PROGRAM</h3>
              </Col>
            </Row>
          </Container>
          <Container className="container-style">
            <h3 className="text-center mb-4">Vision</h3>
            <p
              style={{
                fontSize: "18px",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <strong>
                “To graduate professionally competent Electronics and
                Telecommunication engineers with research aptitude and social
                sensitivity.”
              </strong>
            </p>
          </Container>
          <Container
            className="container-style"
            style={{ textAlign: "justify" }}
          >
            <h3 className="text-center mb-4">Mission</h3>
            <strong>
              <ul>
                <li>
                  To innovate constantly and adopt teaching, learning,
                  evaluation strategies to suit the learners, and ensure
                  academic and research conducive infrastructure.
                </li>
                <li>
                  To ensure fruitful collaborations with academia and industry
                  for excellence in academic and research.
                </li>
                <li>
                  To undertake the continuous value addition of faculty and
                  staff with suitable empowerment policies.
                </li>
                <li>
                  To inculcate sensitivity to societal issues, communication
                  skills and teamwork, lifelong learning attitude, and relevant
                  skills amongst the learners.
                </li>
                <li>
                  To ensure holistic, flexibility, inclusivity and all rounded
                  development of the learners.
                </li>
              </ul>
            </strong>
          </Container>
          <Container className="container-style">
            <h3 className="text-center mb-4">
              Program Education Objectives (PEO)
            </h3>
            <ul>
              <li>
                Establish themselves in their chosen career paths by
                demonstrating technical competence in design, analysis, and
                maintenance of electronics systems, signal processing,
                communication systems, computer network, etc.
              </li>
              <li>
                Demonstrate leadership, communication, and interpersonal skills,
                creativity and innovation, teamwork, and excellent project and
                finance management skills.
              </li>
              <li>
                Contribute towards the next generation of electronics
                technologies with creative and innovative practices.
              </li>
              <li>
                Demonstrate zeal towards lifelong learning, values, ethics,
                sensitivity to global problems, and prove to be dutiful citizens
                for society.
              </li>
            </ul>
          </Container>
          <Container className="container-style">
            <h3 className="text-center mb-4">
              Knowledge and Attitude Profile (WK)
            </h3>
            <ul>
              <li>
                <strong>WK1:</strong> A systematic, theory-based
                understanding of the natural sciences applicable to the
                discipline and awareness of relevant social sciences.
              </li>
              <li>
                <strong>WK2:</strong> Conceptually-based mathematics,
                numerical analysis, data analysis, statistics and formal
                aspects of computer and information science to support
                detailed analysis and modelling applicable to the
                discipline.
              </li>
              <li>
                <strong>WK3:</strong> A systematic, theory-based
                formulation of engineering fundamentals required in the
                engineering discipline.
              </li>
              <li>
                <strong>WK4:</strong> Engineering specialist knowledge that
                provides theoretical frameworks and bodies of knowledge for
                the accepted practice areas in the engineering discipline;
                much is at the forefront of the discipline.
              </li>
              <li>
                <strong>WK5:</strong> Knowledge, including efficient
                resource use, environmental impacts, whole-life cost,
                re-use of resources, net zero carbon, and similar concepts,
                that supports engineering design and operations in a
                practice area.
              </li>
              <li>
                <strong>WK6:</strong> Knowledge of engineering practice
                (technology) in the practice areas in the engineering
                discipline.
              </li>
              <li>
                <strong>WK7:</strong> Knowledge of the role of engineering
                in society and identified issues in engineering practice in
                the discipline, such as the professional responsibility of
                an engineer to public safety and sustainable development.
              </li>
              <li>
                <strong>WK8:</strong> Engagement with selected knowledge in
                the current research literature of the discipline,
                awareness of the power of critical thinking and creative
                approaches to evaluate emerging issues.
              </li>
              <li>
                <strong>WK9:</strong> Ethics, inclusive behaviour and
                conduct. Knowledge of professional ethics, responsibilities,
                and norms of engineering practice. Awareness of the need
                for diversity by reason of ethnicity, gender, age, physical
                ability etc. with mutual understanding and respect, and of
                inclusive attitudes.
              </li>
            </ul>
          </Container>
          <Container className="container-style">
            <h3 className="text-center mb-4">Programme Outcomes (PO)</h3>
            <p>Engineering Graduates will be able to:</p>

            <ul>
              <li>
                <strong>PO1: Engineering Knowledge:</strong> Apply knowledge of
                mathematics, natural science, computing, engineering
                fundamentals and an engineering specialization as specified in
                WK1 to WK4 respectively to develop to the solution of complex
                engineering problems.
              </li>
              <li>
                <strong>PO2: Problem Analysis:</strong> Identify, formulate,
                review research literature and analyze complex engineering
                problems reaching substantiated conclusions with consideration
                for sustainable development. (WK1 to WK4)
              </li>
              <li>
                <strong>PO3: Design/Development of Solutions:</strong> Design
                creative solutions for complex engineering problems and
                design/develop systems/components/processes to meet identified
                needs with consideration for the public health and safety,
                whole-life cost, net zero carbon, culture, society and
                environment as required. (WK5)
              </li>
              <li>
                <strong>
                  PO4: Conduct Investigations of Complex Problems:
                </strong>{" "}
                Conduct investigations of complex engineering problems using
                research-based knowledge including design of experiments,
                modelling, analysis & interpretation of data to provide valid
                conclusions. (WK8).
              </li>
              <li>
                <strong>PO5: Engineering Tool Usage:</strong> Create, select
                and apply appropriate techniques, resources and modern
                engineering & IT tools, including prediction and modelling
                recognizing their limitations to solve complex engineering
                problems. (WK2 and WK6)
              </li>
              <li>
                <strong>PO6: The Engineer and The World:</strong> Analyse and
                evaluate societal and environmental aspects while solving
                complex engineering problems for its impact on sustainability
                with reference to economy, health, safety, legal framework,
                culture and environment. (WK1, WK5, and WK7).
              </li>
              <li>
                <strong>PO7: Ethics:</strong> Apply ethical principles and
                commit to professional ethics, human values, diversity and
                inclusion; adhere to national & international laws. (WK9)
              </li>
              <li>
                <strong>
                  PO8: Individual and Collaborative Teamwork:
                </strong>{" "}
                Function effectively as an individual, and as a member or
                leader in diverse/multi-disciplinary teams.
              </li>
              <li>
                <strong>PO9: Communication:</strong> Communicate effectively
                and inclusively with in the engineering community and society
                at large, such as being able to comprehend and write effective
                reports and design documentation, make effective presentations
                considering cultural, language, and learning differences.
              </li>
              <li>
                <strong>PO10: Project Management and Finance:</strong> Apply
                knowledge and understanding of engineering management
                principles and economic decision-making and apply these to
                one’s own work, as a member and leader in a team, and to
                manage projects and in multi-disciplinary environments.
              </li>
              <li>
                <strong>PO11: Life-Long Learning:</strong> Recognize the need
                for, and have the preparation and ability for i) independent
                and life-long learning ii) adaptability to new and emerging
                technologies and iii) critical thinking in the broadest
                context of technological change.
              </li>
            </ul>
          </Container>
          <Container className="container-style">
            <h3 className="text-center mb-4">
              Programme Specific Outcomes (PSO)
            </h3>
            <ul>
              <li>
                The ability to understand, analyze, design, prototype, maintain
                and troubleshoot circuits and systems in the domain of
                communication, signal processing, embedded and power
                electronics.
              </li>
              <li>
                The ability to demonstrate good communication skills, teamwork,
                project and finance management skills, sensitivity towards
                environment and society, and attitude of lifelong learning.
              </li>
            </ul>
          </Container>

          <Container className="container-style">
            <h3 className="text-center mb-4">Short Term Goals (up to 2027)</h3>
            <ul>
              <li>
                Higher studies enrollment should be at least 15% of the
                graduating batch.
              </li>
              <li>
                Five reputable journal publications per year in the department.
              </li>
              <li>
                Each faculty should be involved in sponsored research and
                consultancy.
              </li>
              <li>100% faculty with Ph.D. qualification.</li>
              <li>One center of excellence in the department.</li>
              <li>State-of-the-art laboratory in the department.</li>
              <li>
                Co-teaching from the industry experts for 5% of program courses.
              </li>
              <li>Each faculty should be involved in outreach activities.</li>
              <li>
                One active collaboration with top layer institutions of the
                country.
              </li>
              <li>One active collaboration with foreign institutions.</li>
              <li>1% visiting professors from industry/foreign university.</li>
              <li>
                Reaching 80% of our alumni and ensuring their participation in
                mentoring our students.
              </li>
            </ul>
          </Container>

          <Container className="container-style">
            <h3 className="text-center mb-4">
              Establish consistency of PEOs with Mission of the Department
            </h3>
            <p>
              (Generate a “Mission of the Department – PEOs matrix “with
              justification and Rationale of the mapping)
            </p>
            <table>
              <tr>
                <th>PEO/M</th>
                <th>M1</th>
                <th>M2</th>
                <th>M3</th>
                <th>M4</th>
                <th>M5</th>
              </tr>
              <tr>
                <td>
                  <b>PEO1</b>
                </td>
                <td>High</td>
                <td>High</td>
                <td>Medium</td>
                <td>Medium</td>
                <td>Medium</td>
              </tr>
              <tr>
                <td>
                  <b>PEO2</b>
                </td>
                <td>Medium</td>
                <td>Medium</td>
                <td>Medium</td>
                <td>High</td>
                <td>High</td>
              </tr>
              <tr>
                <td>
                  <b>PEO3</b>
                </td>
                <td>Medium</td>
                <td>High</td>
                <td>High</td>
                <td>High</td>
                <td>Medium</td>
              </tr>
              <tr>
                <td>
                  <b>PEO4</b>
                </td>
                <td>Medium</td>
                <td>Medium</td>
                <td>Medium</td>
                <td>High</td>
                <td>High</td>
              </tr>
            </table>
            <br />
            <p>
              Where: M1, M2, M3, M4 and M5 are five elements of Mission
              Statement and PEO1, PEO2, PEO3, PEO4 are Program Education
              Objectives statement.
              <br />
              Enter correlation levels 1, 2 or 3, where the correlation levels
              1, 2 or 3 as defined below:
              <br />
              <ol type="1" style={{ marginLeft: "50px" }}>
                <li>Slightly (Low)</li>
                <li>Moderately (Medium)</li>
                <li>Substantial (High)</li>
                <li>If there is no correlation, put “-“</li>
              </ol>
            </p>
          </Container>
        </div>
        <br />
        <div style={{ textAlign: "justify" }}>
          <Container className="global-container text-center" fluid>
            <Row>
              <Col>
                <h3>POSTGRADUATE PROGRAM</h3>
              </Col>
            </Row>
          </Container>
          <Container className="container-style">
            <h3 className="text-center mb-4">Vision</h3>
            <p
              style={{
                fontSize: "18px",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <strong>
                “To graduate professionally competent Electronics and Telecommunication engineers with research aptitude and social sensitivity.”
              </strong>
            </p>
          </Container>
          <Container className="container-style">
            <h3 className="text-center mb-4">Mission</h3>
            <strong>
              <ul>
                <li>
                  To innovate constantly and adopt teaching, learning, evaluation strategies to suit the learners, and ensure academic and research conducive infrastructure.
                </li>
                <li>
                  To ensure fruitful collaborations with academia and industry for excellence in academic and research.
                </li>
                <li>
                  To undertake the continuous value addition of faculty and staff with suitable empowerment policies.
                </li>
                <li>
                  To inculcate sensitivity to societal issues, communication skills and teamwork, lifelong learning attitude, and relevant skills amongst the learners.
                </li>
                <li>
                  To ensure holistic, flexibility, inclusivity and all rounded development of the learners.
                </li>
              </ul>
            </strong>
          </Container>
          <Container className="container-style">
            <h3 className="text-center mb-4">
              Program Education Objectives (PEO)
            </h3>
            <p>Within two years of post graduation:</p>
            <ul>
              <li>
                Employable in the diversified sectors of the core industry,
                public sector or Multinational Corporation in the domain of
                design, analysis and maintenance of electronics systems, signal
                processing, communication systems, computer network etc.
              </li>
              <li>
                Contribute towards the next generation of electronics
                technologies with creative and innovative practices.
              </li>
              <li>
                Competent with attitude towards lifelong learning, values,
                ethics, sensitivity to global problems and prove to be dutiful
                citizens for society.
              </li>
            </ul>
          </Container>
          <Container className="container-style">
            <h3 className="text-center mb-4">Programme Outcomes (PO)</h3>
            <p>Engineering Postgraduates will be able to:</p>

            <ul>
              <li>
                <strong>PO1:</strong> Independently carry out research
                /investigation and development work to solve practical problems.
              </li>
              <li>
                <strong>PO2:</strong> Write and present a substantial technical
                report/document.
              </li>
              <li>
                <strong>PO3:</strong> Demonstrate a degree of mastery over the
                area as per the specialization of the program. The mastery
                should be at a level higher than the requirements in the
                appropriate bachelor program.
              </li>
            </ul>
          </Container>

          <Container className="container-style">
            <h3 className="text-center mb-4">
              Establish consistency of PEOs with Mission of the Department
            </h3>
            <p>
              Generate a “Mission of the Department – PEOs matrix “with
              justification and Rationale of the mapping
            </p>
            <table>
              <tr>
                <th>PEO/M</th>
                <th>M1</th>
                <th>M2</th>
                <th>M3</th>
                <th>M4</th>
                <th>M5</th>
              </tr>
              <tr>
                <td>
                  <b>PEO1</b>
                </td>
                <td>High</td>
                <td>Medium</td>
                <td>Medium</td>
                <td>Medium</td>
                <td>Medium</td>
              </tr>
              <tr>
                <td>
                  <b>PEO2</b>
                </td>
                <td>Medium</td>
                <td>High</td>
                <td>High</td>
                <td>Medium</td>
                <td>Medium</td>
              </tr>
              <tr>
                <td>
                  <b>PEO3</b>
                </td>
                <td>Medium</td>
                <td>Medium</td>
                <td>Medium</td>
                <td>High</td>
                <td>High</td>
              </tr>
            </table>
            <br />
            <p>
              Where: M1, M2, M3, M4 and M5 are five elements of Mission
              Statement and PEO1, PEO2, PEO3 are Program Education Objectives
              statement.
              <br />
              Enter correlation levels 1, 2 or 3, where the correlation levels
              1, 2 or 3 as defined below:
              <br />
              <ol type="1" style={{ marginLeft: "50px" }}>
                <li>Slightly (Low)</li>
                <li>Moderately (Medium)</li>
                <li>Substantial (High)</li>
             </ol>
            </p>
          </Container>
        </div>
      </>
    );
  }
}

export default VisionAndMissionPage;

